import React, { useMemo } from "react";
import styles from "./WidgetCard.module.css";
import Scrollbars from "react-custom-scrollbars-2";
import { WidgetFiltersDisplay } from "./WidgetFiltersDisplay";

export const WidgetAdditionalInfo = ({
    filters,
    dateTypeMetadata,
    filterDocCount,
    totalDocCount,
    selectedFieldName,
    docCount,
    widget,
}) => {
    const percentage = useMemo(
        () =>
            Boolean(totalDocCount && filterDocCount)
                ? ((filterDocCount / totalDocCount) * 100).toFixed(2)
                : 0,
        [filterDocCount, totalDocCount]
    );

    if (widget.gridData.without_header) {
        if (!filters.length) {
            return;
        }
        return (
            <>
                {selectedFieldName?.length > 0 && (
                    <Scrollbars style={{ height: "60px" }} autoHide>
                        <div className={styles.filterListWithoutHeader}>
                            <WidgetFiltersDisplay
                                filters={filters}
                                dateTypeMetadata={dateTypeMetadata}
                            />
                        </div>
                    </Scrollbars>
                )}
            </>
        );
    }
    return (
        <>
            <div className={styles.footerContext}>
                <div>
                    {/* <p className={styles.count}>
                        Date Created: <span> from 01/13/2009 to 01/12/2025</span>
                    </p> */}
                    <p className={styles.count} data-testid="documentCount">
                        Document Count: <span>{docCount}</span>
                    </p>
                    <p className={styles.count} id="">
                        Filter Document Count:{" "}
                        <span>
                            {filterDocCount} ({percentage}%)
                        </span>
                    </p>
                </div>
                {selectedFieldName?.length > 0 && (
                    <Scrollbars style={{ height: "60px" }} autoHide>
                        <div className={styles.filterList}>
                            <WidgetFiltersDisplay
                                filters={filters}
                                dateTypeMetadata={dateTypeMetadata}
                            />
                        </div>
                    </Scrollbars>
                )}
            </div>
        </>
    );
};
